import {PlatformNavbarMenuItem} from "@flexinet/ui-components";
import {
    AiOutlineAppstore,
    AiOutlineCreditCard,
    AiOutlineDashboard,
    AiOutlineHome,
    AiOutlineKey,
    AiOutlineSetting,
    AiOutlineUser
} from "react-icons/ai";
import {PiCookieLight} from "react-icons/pi";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {RiOrganizationChart} from "react-icons/ri";

const ICON_SIZE = '1.5em'

const menuItems: PlatformNavbarMenuItem[] = [
    {
        id: 'home',
        link: '/dashboard',
        label: 'Home',
        icon: <AiOutlineHome size={ICON_SIZE}/>,
        rbac: rbacActions.GetDashboard,
        defaultOpened: true,
        links: [
            {
                id: 'dashboard',
                link: '/dashboard',
                label: 'Dashboard',
                icon: <AiOutlineDashboard size={ICON_SIZE}/>,
                rbac: rbacActions.GetDashboard,
            }, {
                id: 'my-applications',
                link: '/account-applications',
                label: 'My Applications',
                icon: <AiOutlineAppstore size={ICON_SIZE}/>,
                rbac: rbacActions.ListTenantApplications,
            }] as PlatformNavbarMenuItem[],
    },
    {
        id: 'account',
        link: '/user-profile',
        label: 'Settings',
        icon: <AiOutlineSetting size={ICON_SIZE}/>,
        defaultOpened: true,
        rbac: rbacActions.GetUserAccount,
        links: [
            {
                id: 'user-profile',
                link: '/user-profile',
                label: 'Personal Info',
                icon: <AiOutlineUser size={ICON_SIZE}/>,
                rbac: rbacActions.GetUserAccount,
            },
            {
                id: 'reset-password',
                link: '/reset-password/change',
                label: 'Password',
                icon: <AiOutlineKey size={ICON_SIZE}/>,
                rbac: rbacActions.UpdateUserAccount,
            },
            {
                id: 'cookies',
                link: '/account/cookie-preferences',
                label: 'Cookies',
                icon: <PiCookieLight size={ICON_SIZE}/>,
                rbac: rbacActions.UpdateUserAccount,
            },
            {
                id: 'account-info',
                link: '/account/',
                label: 'Account & Billing',
                icon: <AiOutlineSetting size={ICON_SIZE}/>,
                rbac: rbacActions.GetUserAccount,
            }] as PlatformNavbarMenuItem[],
    },
    {
        id: 'organizations',
        link: '/organizations',
        label: 'Organizations',
        icon: <RiOrganizationChart size={ICON_SIZE}/>,
        rbac: rbacActions.GetOrganization,
        defaultOpened: true,
        links: [
            {
                id: 'my-organizations',
                link: '/organizations',
                label: 'My Organizations',
                icon: <RiOrganizationChart size={ICON_SIZE}/>,
                rbac: rbacActions.GetOrganization,
            }
        ] as PlatformNavbarMenuItem[],
    },
    {
        id: 'billing',
        link: '/products',
        label: 'Billing',
        icon: <AiOutlineCreditCard size={ICON_SIZE}/>,
        rbac: rbacActions.ListSubscriptions,
        defaultOpened: true,
        links: [
            {
                id: 'my-products',
                link: '/products',
                label: 'My Products',
                icon: <AiOutlineAppstore size={ICON_SIZE}/>,
                rbac: rbacActions.ListSubscriptions,
            },
            {
                id: 'billing-providers',
                link: '/billing/providers',
                label: 'Billing Providers',
                icon: <AiOutlineCreditCard size={ICON_SIZE}/>,
                rbac: rbacActions.ListSubscriptions,
            }
        ] as PlatformNavbarMenuItem[]
    }];

export const getMenuItems = () => menuItems;

export const findParent = (link: string) => {
    const menuItems = getMenuItems();
    let found = {} as PlatformNavbarMenuItem
    menuItems.forEach(item => {
        if (item.links) {
            item.links.forEach(child => {
                if (child.link === link) {
                    found = item;
                }
            })
        }
    })
    return found as PlatformNavbarMenuItem;
}
